"use client";

import { useUser } from "@clerk/nextjs";

/**
 * Client-side hook to check if current user is admin
 */
export function useIsAdmin(): boolean {
  const { user } = useUser();

  if (!user) {
    return false;
  }

  // Check for admin role in Clerk metadata
  const role = user.publicMetadata?.role as string | undefined;
  return role === "ADMIN";
}
